export const TradeFeeTypes = {
    FORFEIT: "FORFAIT",
    PROPORTIONAL: "PROPORTIONNEL",
}
